/* eslint-disable import/first */
import React from 'react';

import css from './index.module.scss';
import loading from '../../components/Loader/LOADER_v13.gif';
const SetLoader = ({ onClick, className }) => {
  // console.log(loading);
  return (
    <div className={css.loaderRoot}>
      <img src={loading} width="300" alt="" />
    </div>
  );
};

export default SetLoader;
